/**
 * Created by Marko Vukovic marko.vukovic.zg@gmail.com
 */
/**
 * Define application.
 *
 * @returns {{init: Function}}
 */
window.App = function () {
    /**
     * Initialize application.
     */
    var init = function () {
        setTimeout(navigationInit,2000);
        sliderInit();
        showMoreInit();
        formInit();
        ajaxInit();
        cookieNotice();
        if($('select').length){
            startSelectize();
        }
        mobileNavigationInit();
        galleryPrepare();
        galleryInit();
        //VideoJS.setupAllWhenReady();

        $(window).on('resize', function() {
          if(this.resizeTO) clearTimeout(this.resizeTO);
          this.resizeTO = setTimeout(function() {
          $(this).trigger('resizeEnd');
        }, 500);
        });
        $(window).bind('resizeEnd', function() {
          sliderCorrection();
          galleryPrepare();
        });

    };



    var startSelectize = function(){

        var selectizeSelect = $('select')[0],
            dataDefault = selectizeSelect.getAttribute('data-default'),
            dataSelected = selectizeSelect.getAttribute('data-selected');

        var selected = dataSelected ? dataSelected : dataDefault;

        var url = window.location.href;

        $('select').selectize({
            dropdownParent: 'body',
            placeholder : selected,
            onChange : function(value){
                /*var url = window.location.href;
                url = url.substring(0, url.indexOf('/archive-cycles'));
                url= url + '/archive-cycles/'+value;
                window.location.replace(url);*/
                console.log(value);
            }
        });
    };

    var cookieNotice = function(){
        var cookieContainer = $("p.cookies");
        if(readCookie('cookie-message') === 'hide'){
            cookieContainer.hide();
        } else {
            cookieContainer.on('click', function(){
                createCookie('cookie-message', 'hide', 7);
                cookieContainer.hide();
            });
        }

        if(readCookie('language') === 'hr' || readCookie('language') === 'en'){
            $('div.notification').hide();
            $('.notifications').removeClass('notifications');

            if(readCookie('language') === 'hr' && location.href.search('/hr')==-1 && location.href.search('/survey')==-1) {
              location.href="/hr";
            }
        } else {
          var languages = $("p.languages span");
          languages.click(function() {
            var lang = $(this).attr('data-id');
            createCookie('language', lang, 7);
            $('div.notification').hide();
            $('.notifications').removeClass('notifications');
            if(lang=='hr' && location.href.search('/hr')==-1) {
              location.href = '/hr';
            }
            if(lang=='en' && location.href.search('/hr')>-1) {
              location.href = '/';
            }
          });
        }

    };

    // Create cookie
    var createCookie = function(name, value, days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            expires = "; expires="+date.toGMTString();
        }
        else {
            expires = "";
        }
        document.cookie = name+"="+value+expires+"; path=/";
    };

    // Read cookie
    var readCookie = function(name){
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1,c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length,c.length);
            }
        }
        return null;
    };

    /**
     * Initialize slider
     */
    var sliderInit = function () {
        // *** variables
        var slider = $('.slider');
        var slides = $('.slider article');
        var arrowLeft = $('.arrowLeft');
        var arrowRight = $('.arrowRight');
        var pagination = $('aside.pagination ul li');
        var paginationActive = $('aside.pagination div.activeSlide');
        var paginationHover = $('aside.pagination div.hoverSlide');
        var slideCount = $('.slider article').length;
        var windowWidth = $(window).outerWidth();
        var windowHeight = $(window).outerHeight();
        var slideWidth = slides.first().outerWidth();
        var slideMargin = (windowWidth-slideWidth-200)/2
        var activeSlide = 0;
        var todaySlide = 0;
        var correction = 50;
        var arrowRightCorrection=90;
        var arrowLeftCorrection=70;
        // corrections
        if($('main').hasClass('calendar')) {
          arrowRightCorrection=150;
          arrowLeftCorrection=200;
          correction = 150;
          if(windowWidth<1400) {
            arrowRightCorrection=100;
          }
          if(windowWidth<1100) {
            arrowRightCorrection=70;
            arrowLeftCorrection=160;
          }
          if(windowWidth<1024) {
            slideMargin = (windowWidth-slideWidth)/2
            correction = 0;
            arrowLeftCorrection=40;
            arrowRightCorrection=20;
          }
          if(windowWidth<800) {
            arrowLeftCorrection=0;
            arrowRightCorrection=0;
          }
          if(windowHeight<460) {
            $('aside.calendar').hide();
          }
        }
        else {
          // small screen exception
          if(windowWidth<1024) {
            slideMargin = (windowWidth-slideWidth)/2
            correction = 0;
          }
          // mobile layout adjustment
          if(windowWidth<900) {
           $('main.home section.slider article span.mark').each(function(){
             $(this).css('margin-top',$('h5',$(this).parent()).outerHeight()-$(this).outerHeight());
           });
          }

        }

        slider.width(slideCount*(slideWidth+slideMargin));
        slides.each(function() {
          $(this).css("margin-right",slideMargin);
          if($(this).hasClass("featured")) {
            activeSlide = $(this).index();
          }
          if($(this).hasClass("today")) {
            todaySlide = $(this).index();
          }
        });
        // *** pagination
        pagination.each(function(){
            $(this).hover(function() {
              paginationHover.html($(this).attr("data-content"));
              paginationHover.css({"display":"block","left":28*$(this).index()});
              paginationActive.set($(this).index());
            },function() {
              paginationHover.css({"display":"none"});
              paginationActive.css({"display":"none"});
            });
            $(this).click(function() {
              slider.slideTo($(this).index());
            });
        });
        // pagination ux hack
         $('aside.pagination').hover(function(){},function(){
           paginationActive.set(activeSlide);
         });
        // pagination helper
        paginationActive.set = function(slide) {
          paginationActive.css({"display":"block","left":28*slide});
          // added arrow control
          if(slide==0 && activeSlide==0) {arrowLeft.css('opacity','0.3');}else {arrowLeft.css('opacity','1');}
          if(slide==slideCount-1) {arrowRight.css('opacity','0.3');}else {arrowRight.css('opacity','1');}
        };
        // *** slider control
        slider.slideTo = function(slide) {
          $(this).animate({ marginLeft: correction-slideWidth-(slideWidth+slideMargin)*(slide-1)});
          activeSlide=slide;
          slider.attr('data-id', slide);
          paginationActive.set(activeSlide);

        };
        // *** arrow controls
        arrowLeft.css("left",slideMargin/2+arrowLeftCorrection);
        arrowRight.css("right",slideMargin/2+arrowRightCorrection);
        arrowLeft.click(function(){
          if(activeSlide>0) {
            slider.animate({
                marginLeft: '+=' + (slideWidth+slideMargin)
            });
            activeSlide-=1;
            paginationActive.set(activeSlide);
            slider.attr('data-id', activeSlide);
          }
        });
        arrowRight.click(function(){
          if(activeSlide<slideCount-1) {
            slider.animate({
                marginLeft: '-=' + (slideWidth+slideMargin)
            });
            activeSlide+=1;
            paginationActive.set(activeSlide);
            slider.attr('data-id', activeSlide);
          }
        });
        // if there is no featured slide go to closest to today
        if(activeSlide==0) {
          activeSlide = todaySlide;
        }
        // move initial active slide to center
        slider.slideTo(activeSlide);
        // pagination
        paginationActive.set(activeSlide);

    };


    var sliderCorrection = function () {
        // *** variables
        var slider = $('.slider');
        var slides = $('.slider article');
        var arrowLeft = $('.arrowLeft');
        var arrowRight = $('.arrowRight');
        var slideCount = $('.slider article').length;
        var windowWidth = $(window).outerWidth();
        var slideWidth = slides.first().outerWidth();
        var slideMargin = (windowWidth-slideWidth-200)/2
        var correction = 50;
        var arrowRightCorrection=70;
        var arrowLeftCorrection=90;
        //** corrections
        if($('main').hasClass('calendar')) { // calendar
          arrowRightCorrection=150;
          arrowLeftCorrection=200;
          correction = 150;
          if(windowWidth<1400) {
            arrowRightCorrection=100;
          }
          if(windowWidth<1100) {
            arrowRightCorrection=70;
            arrowLeftCorrection=160;
          }
          if(windowWidth<1024) {
            slideMargin = (windowWidth-slideWidth)/2
            correction = 0;
            arrowLeftCorrection=40;
            arrowRightCorrection=20;
          }
          if(windowWidth<800) {
            arrowLeftCorrection=0;
            arrowRightCorrection=0;
          }
        }
        else { // home
          if(windowWidth<1024) { // small screen exception
            slideMargin = (windowWidth-slideWidth)/2
            correction = 0;
          }
        }
        slider.width(slideCount*(slideWidth+slideMargin));
        slides.each(function() {
          $(this).css("margin-right",slideMargin);
        });
        arrowLeft.css("left",slideMargin/2+arrowLeftCorrection);
        arrowRight.css("right",slideMargin/2+arrowRightCorrection);

        slider.slideTo = function(slide) {
          $(this).animate({ marginLeft: correction-slideWidth-(slideWidth+slideMargin)*(slide-1)});
          activeSlide=slide;
          $(this).attr('data-id', activeSlide);
        };

        slider.slideTo(slider.attr('data-id'));
    };


    /**
     * Prepare gallery
     */
     var galleryPrepare = function () {
       var windowWidth = $(window).outerWidth();
       var mainWidth = $('main.news').outerWidth();
       if(windowWidth<961 && $('div.gallery').length>0) {
         $('div.gallery').css('height',mainWidth*0.665);
         $('div.gallery div.container img').css({'height':mainWidth*0.665,'width':mainWidth});
         $('.galleryLeft, .galleryRight').css('top',mainWidth*0.665/2+$('div.gallery').offset().top);
       }
     }
    /**
     * Initialize gallery
     */
    var galleryInit = function () {
        // *** variables
        var gallery = $('div.gallery');
        var container = $('div.gallery div.container');
        var arrowLeft = $('.galleryLeft');
        var arrowRight = $('.galleryRight');
        var slides = $('img', container);
        var slideCount = slides.length;
        var windowWidth = $(window).outerWidth();
        var windowHeight = $(window).outerHeight();
        var slideWidth = slides.first().outerWidth();
        var activeSlide = 0;
        // *** arrow controls
        arrowLeft.css("opacity",0.3);
        arrowLeft.click(function(){
          if(activeSlide>0) {
            container.animate({
                marginLeft: '+=' + (slideWidth)
            });
            activeSlide-=1;
          }
          arrowRight.css("opacity",1);
          if(activeSlide==0) {
            arrowLeft.css("opacity",0.3);
          }
          else {
            arrowLeft.css("opacity",1);
          }
        });
        arrowRight.click(function(){
          if(activeSlide<slideCount-1) {
            container.animate({
                marginLeft: '-=' + (slideWidth)
            });
            activeSlide+=1;
          }
          arrowLeft.css("opacity",1);
          if(activeSlide==slideCount-1) {
            arrowRight.css("opacity",0.3);
          }
          else {
            arrowRight.css("opacity",1);
          }
        });

    };


    var navigationInit = function () {

        // propagate clicks from span to a
        $('header li span').click(function() {
            location.href = $('a',$(this).parent()).attr("href");
        });
        $('aside.note p').click(function() {
            location.href = $('li.survey a').attr("href");
        });
        /*$('aside.documentation p').click(function() {
            location.href = $('li.calendar a').attr("href");
        });*/

        $('header li.about a').addClass("hide");
        // about
        setTimeout(function() { $('header li.about div').addClass("show") }, 100);
        $('header li.about').hover(function() {
          $('header li.about a').removeClass("hide");
          $('header li.about div').removeClass("show");
        },function() {
          $('header li.about a').addClass("hide");
          $('header li.about div').addClass("show");
        });
        // calendar
        $('header li.calendar a').addClass("hide");
        $('header li.calendar').hover(function() {
          $('header li.calendar a').removeClass("hide");
        },function() {
          $('header li.calendar a').addClass("hide");
        });
        // survey
        $('header li.survey a').addClass("hide");
        $('header li.survey').hover(function() {
          $('header li.survey a').removeClass("hide");
        },function() {
          $('header li.survey a').addClass("hide");
        });
        // signature
        $('header li.signature a').addClass("hide");
        $('header li.signature').hover(function() {
          $('header li.signature a').removeClass("hide");
        },function() {
          $('header li.signature a').addClass("hide");
        });
        // note
        if(!$('header aside.note').hasClass("hide")) {
          $('header aside.note').addClass("show");
          $('header aside.note div').click(function() {
            $('header aside.note').removeClass("show");
          });
        }
        // documentation
        $('header aside.documentation').addClass("show");
        $('header aside.documentation div').click(function() {
          $('header aside.documentation').removeClass("show");
        });

    };

    /**
     * Initialize mobile navigation
     */
    var mobileNavigationInit = function () {
        // *** SLIDER STUFF *** //
        // *** variables
        var slider = $('.slider');
        var slides = $('.slider article');
        var arrowLeft = $('li.lft');
        var arrowRight = $('li.rgt');
        var paginationActive = $('aside.pagination div.activeSlide');
        var windowWidth = $(window).outerWidth();
        var slideWidth = slides.first().outerWidth();
        var slideCount = $('.slider article').length;
        var slideWidth = slides.first().outerWidth();
        var slideMargin = (windowWidth-slideWidth)/2
        var activeSlide = 0;
        activeSlide = parseInt(slider.attr('data-id'));
        // *** pagination helper
        paginationActive.set = function(slide) {
          paginationActive.css({"display":"block","left":28*slide});
        };
        // *** arrow controls
        arrowLeft.click(function(){
          if(activeSlide>0) {
            slider.animate({
                marginLeft: '+=' + (slideWidth+slideMargin)
            });
            activeSlide-=1;
            paginationActive.set(activeSlide);
            slider.attr('data-id', activeSlide);
          }
        });
        arrowRight.click(function(){
          if(activeSlide<slideCount-1) {
            slider.animate({
                marginLeft: '-=' + (slideWidth+slideMargin)
            });
            activeSlide+=1;
            paginationActive.set(activeSlide);
            slider.attr('data-id', activeSlide);
          }
        });
        // ** Open & close navigation ** //
        var open = $('li.open');
        var controls = $('nav.mobile ul.controls');
        var navigation = $('header');
        open.click(function(){
          if(open.hasClass('yes')) {
            $('li:not(.open)',controls).show();
            open.removeClass('yes');
            open.html('=');
            navigation.animate({
                height: '60px'
            });
          }
          else {
            $('li:not(.open)',controls).hide();
            open.addClass('yes');
            open.html('✕');
            navigation.animate({
                height: '210px'
            });
          }
        });

        // subpage - navigation behaviour
        if($('body').hasClass('blue') && !$('main').hasClass('calendar')) {
          $(window).scroll(function (e) {
            if($(this).scrollTop()>=$('h1').first().outerHeight()-20){
              $('header').addClass('sticky');
            }
            else {
              $('header').removeClass('sticky');
            }

          });
        }

    };

    var showMoreInit = function () {
      $('body.blue main.subpage article').click(function() {
          $('div',$(this)).toggleClass("show");
          $('p',$(this)).first().toggleClass("hide");
      });

      $('body.blue header nav').click(function() {
          location.href= $('a',$(this)).attr("href");
      });

      $('body.blue main.calendar table tr td[data-url]').each(function(){
        if($(this).attr('data-url')!='') {
          $(this).addClass("link");
          $(this).click(function() {
              location.href = $(this).attr('data-url');
          });
        }
        $(this).hover(function() {
            $('p.calendarHover',$(this).parent().parent().parent().parent()).html($(this).attr('data-name'));
        },function() {
            $('p.calendarHover').html('&nbsp;');
        });

      });
    };

    var ajaxInit = function () {
      // ajax delete of files
      $('body.blue main form div.files p span').click(function() {
        $.ajax({
          url: $(this).attr("data-href"),
          context: $(this)
        }).done(function() {
          $(this).parent().css("display","none");
        });
      });
    };

    var formInit = function () {

      // next step behaviour
      $('body.blue input.hasNextStep').click(function() {
          if($(this).attr('type')=="radio") {
            $('div.nextStep', $(this).parent()).removeClass("hide");
          }
          else {
            $('div.nextStep', $(this).parent()).toggleClass("hide");
          }
          $('input.nextStep', $(this).parent()).val('');
      });
      // show next step if checked
      $('body.blue input.hasNextStep').each(function() {
          if($(this).is( ":checked" )) {
            $('div.nextStep', $(this).parent()).removeClass("hide");
          }
      });
      // click on other radio buttons hides nextStep div
      $('body.blue input:radio').click(function() {
        if(!$(this).hasClass('hasNextStep')) {
          $('div.nextStep',$(this).parent().parent()).addClass("hide");
        }
      });

      // yes/no -> show more
      $('body.blue span.yes').click(function() {
          $(this).addClass("on");
          $('span.no',$(this).parent()).removeClass("on");
          $('input', $(this).parent()).val("yes");
          var id = $(this).parent().attr("data-id");
          $('.'+id).removeClass("hide");
          // yes-no correction
          $('input', $(this).parent()).removeClass('invalid');
          $('span[data-id='+$('input', $(this).parent()).attr('name')+']').remove();

      });
      $('body.blue span.no').click(function() {
          $(this).addClass("on");
          $('span.yes',$(this).parent()).removeClass("on");
          $('input', $(this).parent()).val("no");
          var id = $(this).parent().attr("data-id");
          $('.'+id).addClass("hide");
          // yes-no correction
          $('input', $(this).parent()).removeClass('invalid');
          $('span[data-id='+$('input', $(this).parent()).attr('name')+']').remove();
      });
      // show if checked
      $('body.blue span.yes').each(function() {
          if($('input', $(this).parent()).val()=='yes'){
            $(this).addClass("on");
            var id = $(this).parent().attr("data-id");
            $('.'+id).removeClass("hide");
          }
      });
      $('body.blue span.no').each(function() {
        if($('input', $(this).parent()).val()=='no'){
          $(this).addClass("on");
        }
      });

      // contract question exeption
      $('body.blue input.legalQuestion').open=false;
      $('body.blue input.legalQuestion').click(function() {
          if(!$(this).open) {
            $(this).open=true;
            $('input.nextStep', $(this).parent()).val('');
            // reset
            $('div.nextStep.legalQuestion').addClass("hide");
            $('div.lastStep.legalQuestion').addClass("hide");
            $('body.blue span.yes.legalQuestion').removeClass("on");
            $('body.blue span.no.legalQuestion').removeClass("on");
            // set
            $('div.nextStep', $(this).parent()).removeClass("hide");
          }
      });
      $('body.blue span.yes.legalQuestion').click(function() {
          $(this).addClass("on");
          var id=$(this).attr("data-id");
          $('body.blue span.no.legalQuestion.'+id).removeClass("on");
          $('input.lastStepLegalQuestion.'+id).val('');
          $('div.lastStep.legalQuestion.'+id).removeClass("hide");
      });
      $('body.blue span.no.legalQuestion').click(function() {
          $(this).addClass("on");
          var id=$(this).attr("data-id");
          $('body.blue span.yes.legalQuestion.'+id).removeClass("on");
          $('input.lastStepLegalQuestion.'+id).val('');
          $('div.lastStep.legalQuestion.'+id).addClass("hide");
      });
      // show if checked
      $('body.blue input.legalQuestion').each(function() {
          if($(this).is( ":checked" )) {
            $(this).open=true;
            $('div.nextStep', $(this).parent()).removeClass("hide");
            var id=$(this).attr("data-id");
            if($('input.'+id,$(this).parent()).val()=='yes') {
              $('body.blue span.yes.legalQuestion.'+id).addClass("on");
              $('div.lastStep.legalQuestion.'+id).removeClass("hide");
            }
            if($('input.'+id,$(this).parent()).val()=='no') {
              $('body.blue span.no.legalQuestion.'+id).addClass("on");
            }
          }
      });

      // *** validation behaviour
      // submit
      $('body.blue form button').click(function(e) {
        var stop=false;
        // text + textarea
        $('body.blue input[type=text], body.blue textarea').each(function() {
          if($(this).val()=='') {
            if(!$(this).hasClass('skip')) {
              $(this).addClass('invalid');
              stop = true;
              if (!$('span[data-id='+$(this).attr('name')+']').length) {
                if($(this).parent().is('fieldset')) {
                  $(this).before('<span class="error" data-id="'+$(this).attr('name')+'">Please provide an answer.</span>');
                }
                else {
                  $(this).parent().parent().before('<span class="error" data-id="'+$(this).attr('name')+'">Please provide an answer.</span>');
                }
              }
            }
          }
        });
        // radio and checkbox
        $('body.blue input:radio, body.blue input:checkbox').each(function() {
          if($(this).is( ":checked" )) {
            $('ul',$(this).parent().parent().parent()).addClass("answered");
          }
        });
        $('body.blue input:radio, body.blue input:checkbox').each(function() {
          if(!$('ul',$(this).parent().parent().parent()).hasClass("answered") && !$('ul',$(this).parent().parent().parent()).hasClass("skip")) {
            stop = true;
            $(this).addClass('invalid');
            if (!$('span[data-id='+$(this).attr('name').replace('[]','')+']').length) {
              if($(this).parent().is('fieldset')) {
                $(this).before('<span class="error" data-id="'+$(this).attr('name').replace('[]','')+'">Please provide an answer.</span>');
              }
              else {
                $(this).parent().parent().before('<span class="error" data-id="'+$(this).attr('name').replace('[]','')+'">Please provide an answer.</span>');
              }
            }
          }
        });
        // yes-no
        $('body.blue input[type=hidden].check').each(function() {
          if($(this).val()=='') {
            if(!$(this).hasClass('skip')) {
              $(this).addClass('invalid');
              stop = true;
              if (!$('span[data-id='+$(this).attr('name')+']').length) {
                $('label[for="'+$(this).attr('name')+'"]').before('<span class="error" data-id="'+$(this).attr('name')+'">Please provide an answer.</span>');
              }
            }
          }
        });

        if(stop) {
          e.preventDefault();
          $(window).scrollTop(0);
          // text & textarea - remove error if corrected
          $('body.blue input[type=text].invalid, body.blue textarea.invalid').blur(function() {
            if($(this).val()!='') {
              $(this).removeClass('invalid');
              $('span[data-id='+$(this).attr('name')+']').remove();
            }
          });
          // radio & checkbox - remove error if corrected
          $('body.blue input:radio.invalid, body.blue input:checkbox.invalid').click(function() {
            $(this).removeClass('invalid');
            $('span[data-id='+$(this).attr('name').replace('[]','')+']').remove();
          });
          // yes-no - remove error if corrected
          // see above - yes-no corrected
        }

      });

      // init after submit.
      $('body.blue.errors input[type=text], body.blue.errors textarea').each(function() {
          if($(this).val()!='' && !$(this).hasClass('skip')) {
              $(this).addClass('valid');
              $('label[for="'+$(this).attr('name')+'"]').addClass('valid');
              $('span[data-id='+$(this).attr('name')+']').remove();
          }
      });

      // *** pagination
      var pagination = $('aside.surveyPagination ul li');
      var paginationActive = $('aside.surveyPagination div.activeSlide');
      var paginationHover = $('aside.surveyPagination div.hoverSlide');
      var windowWidth = $(window).outerWidth();

      var activeSlide = 0;

      pagination.each(function(){
          if($(this).hasClass("active")) {
            activeSlide = $(this).index();
          }
          $(this).hover(function() {
            paginationHover.html($(this).attr("data-content"));
            paginationHover.css({"display":"block","left":windowWidth/2-86+23*$(this).index()});
            paginationActive.set($(this).index());
          },function() {
            paginationHover.css({"display":"none"});
            paginationActive.css({"display":"none"});
          });
          $(this).click(function() {
            location.href= '/survey/' + $(this).attr("data-url");
          });
      });
      // pagination ux hack
       $('aside.surveyPagination').hover(function(){},function(){
         paginationActive.set(activeSlide);
       });
      // pagination helper
      paginationActive.set = function(slide) {
        paginationActive.css({"display":"block","left":windowWidth/2-88+23*slide});
      };
      // set pagination
      paginationActive.set(activeSlide);

    };

    return {init: init};
};
